export default __webpack_public_path__ + "locales/hy-AM/FormGallery.json?hash=9f460e9e4cdf4c4855eae18e9368a93b";